module.exports = __webpack_public_path__ + "img/stork.857bd38c.svg";